import Person from "@/models/People/Person.js";

export default class Section {
  sectionId;
  name;
  institutionId;
  extSysApiSectionId;
  hasConfidentialFoldersForUser;
  teachers;
  students;

  constructor(apiSection) {
    if (apiSection) {
      this.sectionId = apiSection.sectionId;
      this.name = apiSection.name;
      this.institutionId = apiSection.institutionId;
      this.extSysApiSectionId = apiSection.extSysApiSectionId;
      this.hasConfidentialFoldersForUser = apiSection.hasConfidentialFoldersForUser;
      this.teachers = apiSection.teachers?.map(t => new Person(t)) || [];
      this.students = apiSection.students?.map(s => new Person(s)) || [];
    }
  }
}
